import { post } from '../axios'

// 分类列表
export function queryPageTaskCategory(map) {
  return post(`${process.env.VUE_APP_TASK}taskCategory/list`, map)
}

// 新增分类
export function addTaskCategory(map) {
  return post(`${process.env.VUE_APP_TASK}taskCategory/add`, map)
}

// 更新分类
export function updateTaskCategory(map) {
  return post(`${process.env.VUE_APP_TASK}taskCategory/update`, map)
}

// 删除分类
export function deleteTaskCategory(map) {
  return post(`${process.env.VUE_APP_TASK}taskCategory/del`, map)
}

// 查询所有分类
export function getAllTaskCategory(map) {
  return post(`${process.env.VUE_APP_TASK}taskCategory/getAll`, map)
}

// 任务列表
export function queryPageTaskInfo(map) {
  return post(`${process.env.VUE_APP_TASK}taskInfo/list`, map)
}

// 新增任务
export function addTaskInfo(map) {
  return post(`${process.env.VUE_APP_TASK}taskInfo/add`, map)
}

// 更新任务
export function updateTaskInfo(map) {
  return post(`${process.env.VUE_APP_TASK}taskInfo/update`, map)
}

// 删除任务
export function deleteTaskInfo(map) {
  return post(`${process.env.VUE_APP_TASK}taskInfo/del`, map)
}

// 查询所有任务
export function getAllTaskInfo(map) {
  return post(`${process.env.VUE_APP_TASK}taskInfo/getAll`, map)
}

// 修改状态
export function updateTaskInfoByStatus(map) {
  return post(`${process.env.VUE_APP_TASK}taskInfo/updateByStatus`, map)
}

// 任务详情
export function detailTaskInfo(map) {
  return post(`${process.env.VUE_APP_TASK}taskInfo/detail`, map)
}

// SDK列表
export function queryPageTaskUi(map) {
  return post(`${process.env.VUE_APP_TASK}taskUi/list`, map)
}

// 新增SDK
export function addTaskUi(map) {
  return post(`${process.env.VUE_APP_TASK}taskUi/add`, map)
}

// 更新SDK
export function updateTaskUi(map) {
  return post(`${process.env.VUE_APP_TASK}taskUi/update`, map)
}

// 删除SDK
export function deleteTaskUi(map) {
  return post(`${process.env.VUE_APP_TASK}taskUi/del`, map)
}
